import Vue from 'vue'
import App from './App.vue'

import router from './router/router'
import store from './store/store'

import vuetify from './plugins/vuetify'
import axios from './plugins/axios'

import VueDayjs from 'vue-dayjs-plugin'
Vue.use(VueDayjs)

import Vue2Editor from 'vue2-editor'
Vue.use(Vue2Editor)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr, {
	plyr: {
		// debug: true,
		i18n: {
			speed: 'Velocidade',
			normal: 'Normal',
			quality: 'Resolução',
		},
  },
  emit: ['ended']
})

import './registerServiceWorker' 

Vue.config.productionTip = false

let host = window.location.hostname
if(host != 'localhost'){
	document.onkeydown = function(e) {
		if (event.keyCode == 123) {
			console.log('You cannot inspect Element')
			return false
		}
		if (e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
			console.log('You cannot inspect Element')
			return false
		}
		if (e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
			console.log('You cannot inspect Element')
			return false
		}
		if (e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
			console.log('You cannot inspect Element')
			return false
		}
		if (e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
			console.log('You cannot inspect Element')
			return false
		}
	}
	document.addEventListener('contextmenu', (e) => e.preventDefault())
}

new Vue({
	router,
	store,
	vuetify,
	axios,
	render: (h) => h(App),
}).$mount('#app')